import type { RewardKind } from './types'

export type RewardFlow = 'choice' | 'roulette' | 'none'

export const resolveRewardFlow = (quest: {
  active_rewards: boolean
  reward_kind: RewardKind
}): RewardFlow => {
  if (!quest.active_rewards) return 'none'
  return quest.reward_kind
}
